import React from "react";
import Header from "../components/Header";
import TallyEmbed from "../components/TallyEmbed";
import Footer from "../components/Footer";
import FAQAccordion from "../components/FAQAccordion";
import * as UsefulButtons from "../components/UsefulButtons";
import { Helmet } from "react-helmet-async";

function Home() {
  const navLinks = [
    { to: "#", label: "Home" },
    { to: "#whatWeDo", label: "What We Do" },
    { to: "#ourSolutions", label: "Our Solutions" },
    { to: "#howItWorks", label: "How It Works" },
    { to: "/journey", label: "Our Journey" },
    { to: "/blog", label: "Blogs & Insights" },
    { to: "/get-in-touch", label: "Support" },
  ];

  return (
    <>
    <Header links={navLinks} />
    <Helmet>
        <title>DataPulse AI | Managed Automation & AI for Smarter Growth 🚀</title>

        <meta name="robots" content="index, follow"/>

        {/* Structured Data: Organization */}
        <script type="application/ld+json">
            {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "DataPulse AI",
            "url": "https://www.mydatapulse.co.uk",
            "logo": "https://www.mydatapulse.co.uk/logo-clean-large.png",
            "description": "Free up time and scale your business smarter with automation and AI - fully managed by DataPulse AI. No hiring, no tech hassle, no learning curve. Just results.",
            "sameAs": [
                "https://www.linkedin.com/company/mydatapulse",
            ]
            })}
        </script>
    </Helmet>
    <main>
      {/* <!-- Start block */}
      <section className="bg-white dark:bg-gray-900">
          <div className="grid max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:grid-cols-12 lg:pt-28">
              <div className="mr-auto place-self-center lg:col-span-7">
                  {/* <h1 className="max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white"><text className="text-title-highlight">We </text>automate what slows you down. <text className="text-title-highlight">We </text> scale what drives your growth. So <text className="text-title-highlight">You </text> can focus on what matters.</h1> */}
                  <h1 className="max-w-2xl mb-4 text-5xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl">We <text className="text-title-purple">automate</text>, <text className="text-title-purple">scale</text> and <text className="text-title-purple">deliver</text> - so you can focus on what <text className="text-blue-600">matters</text></h1>
                  <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                    Our team of experts at DataPulse AI designs, builds, and runs AI-powered automation systems tailored to your business - including automated workflows, intelligent chatbots, and real-time analytics.<br/><br/>We handle it all - no tech headaches, no hiring, no steep learning curve.
                  <br/>
                  <br/>
                  Just measurable <text className="text-blue-600 font-semibold">results</text> ✅
                  </p>
                    <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4">
                        <a href="#getInTouch" className="flex-1 px-4 inline-flex items-center justify-center px-6 py-3 text-sm font-medium text-gray-900 border border-gray-200 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white">
                            <img className="h-8 mr-2 text-gray-500 dark:text-gray-400" src="/assets/images/whatsapp.svg" alt="WhatsApp"/>
                            <span>Get in touch on <text className="text-title-purple">WhatsApp</text> now!</span>
                        </a>
                        <a href="https://www.mydatapulse.co.uk/appointment" target="_blank" rel="noopener noreferrer" className="flex-1 px-4 inline-flex items-center justify-center px-6 py-3 text-sm font-medium text-gray-900 border border-gray-200 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white">
                            <img className="h-8 mr-2 text-gray-500 dark:text-gray-400" src="/assets/images/DiscoverySessionImg.png" alt="Discovery Session"/>
                            <span>Book your <text className="text-title-purple">FREE 1:1 Strategy</text> call</span>
                        </a>
                        <a href="/blog" className="flex-1 px-4 inline-flex items-center justify-center px-6 py-3 text-sm font-medium text-gray-900 border border-gray-200 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white">
                            <img className="h-8 mr-2 text-gray-500 dark:text-gray-400" src="/assets/images/blog-icon.png" alt="Blog Icon"/>
                            <span>Check out our <text className="text-title-purple">Blogs & Insights!</text></span>
                        </a>
                        {/* <a href="#vision" className="flex-1 px-4 inline-flex items-center justify-center px-6 py-3 text-sm font-medium text-gray-900 border border-gray-200 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white">
                            <img className="w-6 h-6 mr-2 text-gray-500 dark:text-gray-400" src="/assets/images/ppt_logo.png" alt="logo image"/>
                            <span>Explore our Vision: <text className="text-title-purple">Build tomorrow, today</text></span>
                        </a> */}
                        </div>
                    <br/>

              </div>
              <div className="w-full justify-center-logo lg:mt-0 lg:col-span-5 lg:flex">
                  <div className="max-w-screen-md text-center">
                      <br/>
                          <img className="pb-8" src="/assets/images/logo-big.png" alt="logo image"/>
                          <span className="font-bold text-blue-600">Part of the DataPulse AI family:</span>
                          <a href="https://www.convu.ai" target="_blank" rel="noopener noreferrer">
                              <img src="icons/convu_logo_blue.png" alt="convu ai"/>
                          </a>
                      <br/>
                  </div>
              </div>
          </div>
      </section>
      {/* <!-- End block */}

      {/* <!-- Start block */}
      <section className="bg-white dark:bg-gray-900">
          <div className="max-w-screen-xl px-4 pb-8 mx-auto lg:pb-16">
            <p className="max-w-2xl mb-4 font-light text-gray-500 md:text-lg lg:text-xl dark:text-gray-400">
            Proud to be supported by:
            </p>
              <div className="grid gap-8 text-gray-500 sm:gap-12 sm:grid-cols-3 lg:grid-cols-5 dark:text-gray-400">
                <a href="https://www.nvidia.com/en-us/startups/" className="flex items-center lg:justify-center" target="_blank" rel="noopener noreferrer">
                    <img className="logo-trademark hover:text-gray-900 dark:hover:text-white" src="/assets/images/nvidia-inception-badge.png" alt="Supported by logo"/>
                </a>
                    <a href="https://aws.amazon.com/what-is-cloud-computing" className="p-3 flex items-center lg:justify-center"><img src="https://d0.awsstatic.com/logos/powered-by-aws.png" alt="Powered by AWS Cloud Computing"/>
                </a>
                <a href="https://cloud.google.com/startup?hl=en" className="flex items-center lg:justify-center" target="_blank" rel="noopener noreferrer">
                    <img className="logo-trademark hover:text-gray-900 dark:hover:text-white" src="/assets/images/google_cloud_logo.png" alt="Supported by logo"/>
                </a>
                {/* <a href="#" className="flex items-center lg:justify-center">
                    <img className="logo-trademark hover:text-gray-900 dark:hover:text-white" src="/assets/images/nvidia-inception-badge.png" alt="Supported by logo"/>
                </a> */}
                {/* <a href="#" className="flex items-center lg:justify-center">
                    <img className="logo-trademark hover:text-gray-900 dark:hover:text-white" src="/assets/images/nvidia-inception-badge.png" alt="Supported by logo"/>
                </a> */}
              </div>
          </div>
      </section>
      {/* <!-- End block */}

        {/* <!-- Start block --> */}
        <section id="whatWeDo" className="bg-gray-50 dark:bg-gray-900">
        <div className="max-w-screen-xl px-4 py-10 mx-auto lg:py-8 lg:px-6 text-center">
            <div className="mx-auto mb-8 text-center lg:mb-12">
            <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900">
                Built For Your Business - Designed Around the Way You Work
            </h2>
            <p className="mb-5 font-light text-gray-500 sm:text-xl">
            We connect to tools you already use - Google Sheets, Slack, WhatsApp, CRMs - to eliminate the manual work slowing you down.
            </p>
            </div>

            <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">

            {/* <!-- Card 1: Everyday Problems We Fix --> */}
            <a href="/blog/broken-workflows" className="block hover:no-underline" title="Click to explore industry problems on our Blog & Insights" target="_blank">
                <div className="group flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border rounded-lg shadow border-purple-700 hover:bg-purple-100 xl:p-8">
                <h3 className="mb-4 text-2xl font-semibold group-title-purple">💬 The Problems You Face</h3>
                <ul className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                {[
                    <>
                    <strong className="text-gray-900 dark:text-white group-title-purple">Dentists</strong> chasing patients to confirm appointments
                    </>,
                    <>
                    <strong className="text-gray-900 dark:text-white group-title-purple">Founders</strong> stuck rebuilding the same reports every Monday
                    </>,
                    <>
                    <strong className="text-gray-900 dark:text-white group-title-purple">Private equity</strong> teams rushing to portfolio metrics across 5 different data sources
                    </>,
                    <>
                    <strong className="text-gray-900 dark:text-white group-title-purple">Accountants</strong> manually running attendance in WhatsApp
                    </>,
                ].map((item, idx) => (
                    <li key={idx} className="flex items-center">
                    <svg
                        className="w-5 h-5 pt-[2px] mr-2 text-title-purple shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                    </svg>
                    <span>{item}</span>
                    </li>
                ))}
                </ul>
                <br/>
                <p className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                    Each looks different - but they’re the same underneath: broken workflows and too much manual effort.
                </p>
                <br/>
                <h3 className="mb-4 text-2xl font-semibold group-title-purple">Sound Familiar?</h3>

                </div>
            </a>

            {/* <!-- Card 2: What That Unlocks --> */}
            <a href="/blog/systems-that-scale" className="block hover:no-underline" title="Explore how DataPulse AI solves these problems in our Blog & Insights" target="_blank">

                <div className="group flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border rounded-lg shadow border-purple-700 hover:bg-purple-100 xl:p-8">
                <h3 className="mb-4 text-2xl font-semibold group-title-purple">🚀 What DataPulse AI Does</h3>
                <ul className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                    {[
                    <>
                    <strong className="text-gray-900 dark:text-white group-title-purple">Workflows</strong> that send automated reminders, confirmations, and follow-ups on WhatsApp
                    </>,
                    <>
                    <strong className="text-gray-900 dark:text-white group-title-purple">Dashboards</strong> that pull live metrics from CRMs, Google Sheets, or booking platforms - all in one view
                    </>,
                    <>
                    <strong className="text-gray-900 dark:text-white group-title-purple">Systems</strong> that connect databases and communication tools like Slack to alert you when things change
                    </>,
                    <>
                        <strong className="text-gray-900 dark:text-white group-title-purple">Less reliance</strong> on individuals to “keep it all running”
                    </>,
                    ].map((item, idx) => (
                        <li key={idx} className="flex items-center">
                        <svg
                        className="w-5 h-5 pt-[2px] mr-2 text-title-purple shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        >
                        <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                        </svg>
                        <span>{item}</span>
                    </li>
                    ))}
                </ul>
                <br />
                <p className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                    With the manual work gone, your team gets back time - for growth, strategy, and what really matters.
                </p>
                </div>
            </a>

            {/* <!-- Card 3: Why Teams Choose DataPulse AI--> */}
            <a href="/blog/why-teams-choose-us" className="block hover:no-underline" title="Click to explore why teams choose DataPulse AI in our Blog & Insights" target="_blank">
                <div className="group flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border rounded-lg shadow border-purple-700 hover:bg-purple-100 xl:p-8">
                <h3 className="mb-4 text-2xl font-semibold group-title-purple">🏆 Why Teams Choose Us</h3>
                <ul className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                    {[
                    <>
                        <strong className="text-gray-900 dark:text-white group-title-purple">Minimal new software</strong> - we plug into what you already use
                    </>,
                    <>
                        <strong className="text-gray-900 dark:text-white group-title-purple">Expertise on Demand</strong> - access automation specialists without the cost or commitment of hiring in-house
                    </>,
                    <>
                        <strong className="text-gray-900 dark:text-white group-title-purple">Done-for-you automation</strong> setup & support with no internal tech team needed
                    </>,
                    <>
                        <strong className="text-gray-900 dark:text-white group-title-purple">Real humans</strong> solving real inefficiencies
                    </>
                    ].map((item, idx) => (
                        <li key={idx} className="flex items-center">
                        <svg
                        className="w-5 h-5 pt-[2px] mr-2 text-title-purple shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        >
                        <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                        </svg>
                        <span>{item}</span>
                    </li>
                    ))}
                </ul>
                <br />
                <p className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                    It's more than automation - it’s smoother systems, faster growth, and peace of mind.
                </p>
                </div>
            </a>
            </div>


            {/* CTA Button */}
            <br />
            <div className="p-4 mt-2">
            <UsefulButtons.ChatWithTeamHomeButton text="💡 Book your FREE Discovery Call now!" />
            </div>
        </div>
        </section>
        {/* <!-- End block --> */}

        {/* <!-- Start block */}
        <section id="ourSolutions" className="bg-white">
          <div className="max-w-screen-xl px-4 py-10 mx-auto space-y-12 lg:space-y-20 lg:px-6">

                <div className="mx-auto text-center">
                    <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900">
                        Designing Solutions That Move You Forward
                    </h2>
                    <text className="font-light text-gray-500 sm:text-xl dark:text-gray-400">
                        Innovating where it matters - to save time, cut complexity, and fuel your growth.
                    </text>
                </div>

                <div className="items-center gap-8 lg:grid lg:grid-cols-2" style={{ marginTop: '2.5rem' }}>
                {/* <!-- Row: Digital Presence */}
                    <div className="text-gray-500 sm:text-lg">
                        <p className="text-lg font-medium text-title-purple">Be seen. Be trusted. Be chosen.</p>
                        <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">Digital Presence</h2>
                        <p className="mb-8 font-light lg:text-xl">
                            Your website is your first handshake with today’s customer. It should build trust, communicate clearly, and drive action.
                            <br/><br/>
                            At DataPulse AI, we design digital journeys that perform with purpose - not just look pretty:
                        </p>
                        <ul role="list" className="space-y-5 my-7">
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">A conversion-focused, high-performing website</span>
                            </li>
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Smart integrations that turn visits into bookings</span>
                            </li>
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Consistent branding across every digital touchpoint</span>
                            </li>
                        </ul>
                        <p className="font-light lg:text-xl">
                            Whether you're starting fresh or refining your presence, we help you stand out - with the message, design, and tech to grow your business.
                        </p>
                    </div>
                    <img className="w-full mb-4 rounded-lg lg:mb-0 lg:flex" src="/assets/images/website_creation_demo.png" alt="demo website feature image"/>
                </div>

                {/* <!-- Row: Automation Solutions */}
                <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                    <img className="hidden w-full mb-4 rounded-lg lg:mb-0 lg:flex" src="/assets/images/tableau_slide_1.png" alt="feature image 2"/>
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">
                        <p className="text-lg font-medium text-title-purple">Redefine how work gets done</p>
                        <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">Automation Solutions</h2>
                        <p className="mb-8 font-light lg:text-xl">
                            Repetitive tasks, messy processes, and disconnected tools hold businesses back.
                            <br/><br/>
                            With DataPulse AI, you can outsource your automation to us! We design, build, and run it all for you - so you and your team can focus on what matters most for your business.

                        </p>
                        <ul role="list" className="space-y-5 my-7">
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Have experts eliminate repetitive admin and manual tasks</span>
                            </li>
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Reduce costs by minimising human error</span>
                            </li>
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Free your team to focus on strategy and innovation</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* <!-- Row: Data Analytics & Insights */}
                <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">
                        <p className="text-lg font-medium text-title-purple">Embrace tomorrow, by starting today</p>
                        <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">Data Analytics & Insights</h2>
                        <p className="mb-8 font-light lg:text-xl">
                            Data isn’t just information - it’s leverage.
                            <br/><br/>
                            At DataPulse AI, our analytics solutions go beyond dashboards. We help you capture the right data at the right time - so you can make smarter decisions, faster.
                        </p>
                        <ul role="list" className="space-y-5 my-7">
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Dashboards tailored to your business goals, surfacing key metrics from CRMs, forms, and spreadsheets in one clear view</span>
                            </li>
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Automated data capture from the tools you already use, eliminating manual tracking</span>
                            </li>
                            <li className="flex space-x-3">
                                <svg className="w-5 h-5 text-title-purple shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
                                </svg>
                                <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Predictive AI driven analytics that uncover trends early and turn insight into action</span>
                            </li>
                        </ul>
                    </div>
                    <img className="w-full mb-4 rounded-lg lg:mb-0 lg:flex" src="/assets/images/2_tableau_slide_1.png" alt="dashboard feature image"/>
                </div>

                <div className="flex flex-wrap justify-center gap-4">
                    <UsefulButtons.ChatOnWhatsAppButton text="Get in touch!"/>
                    <UsefulButtons.ChatWithTeamHomeButton text="📋 Send an Enquiry"/>
                </div>
          </div>
        </section>

      {/* <!-- Start block */}
      <section className="bg-gray-50 dark:bg-gray-800">
          <div className="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-16 lg:px-6">
              <figure className="mx-auto">
                  <svg className="h-12 mx-auto mb-3 text-gray-400 dark:text-gray-600" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z" fill="currentColor"/>
                  </svg>
                  <blockquote>
                      <p className="text-lg font-medium text-gray-900 md:text-lg dark:text-white">"DataPulse AI streamlined our operations and eliminated so much manual work. We’re saving time, cutting costs, and making faster decisions - it’s been a game changer!"</p>
                  </blockquote>
                  <figcaption className="flex items-center justify-center mt-6 space-x-3">
                      {/* <img className="w-6 h-6 rounded-full" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/michael-gouch.png" alt="profile picture"/> */}
                      <div className="flex items-center divide-x-2 divide-gray-500 dark:divide-gray-700">
                          <div className="pr-3 font-medium text-gray-900 dark:text-white">Will Fender</div>
                          <div className="pl-3 text-sm font-light text-gray-500 dark:text-gray-400">COO of TheStudySpark</div>
                      </div>
                  </figcaption>
              </figure>
          </div>
        </section>
      {/* <!-- End block  */}

      {/* <!-- Start block */}
      <section id="howItWorks" className="bg-white dark:bg-gray-900">
          <div className="max-w-screen-xl px-4 py-10 mx-auto lg:py-24 lg:px-6 text-center">
              <div className="mx-auto mb-8 text-center lg:mb-12">
                  <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">How It Works (3 Steps)</h2>
                  <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">We partner with forward-thinking, growth-driven businesses that recognise the long-term value of innovation.</p>
              </div>
              <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
                  {/* <!-- Pricing Card */}
                  <div className="flex flex-col group max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-purple-700 bg-gray-50 hover:bg-purple-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
                      <h3 className="mb-4 text-2xl font-semibold group-title-purple">Discovery Session</h3>
                      <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">Together we'll dive into your workflows, discuss pain points, and explore opportunities to make the biggest impact - while ensuring we’re a great fit for each other.</p>
                      <div className="flex items-baseline justify-center my-6">
                          <img className="w-50pct flex mt-auto rounded-lg lg:mb-0 lg:flex" src="/assets/images/DiscoverySessionImg.png" alt="Discovery Session Image"/>
                      </div>
                  </div>
                  {/* <!-- Pricing Card */}
                  <div className="flex flex-col group max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-purple-700 bg-gray-50 hover:bg-purple-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
                      <h3 className="mb-4 text-2xl font-semibold group-title-purple">Action Plan</h3>
                      <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">We come back with a tailored roadmap - built around your goals - with clear timelines, costings, and implementation steps we’ll refine together.</p>
                      <div className="flex items-baseline justify-center my-6">
                          <img className="w-50pct rounded-lg lg:mb-0 lg:flex" src="/assets/images/ActionPlanImg.png" alt="Action Plan Image"/>
                      </div>
                  </div>
                  {/* <!-- Pricing Card */}
                  <div className="flex flex-col group max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-purple-700 bg-gray-50 hover:bg-purple-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
                      <h3 className="mb-4 text-2xl font-semibold group-title-purple">Delivery</h3>
                      <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">We handle the build, testing, and rollout - keeping you in the loop every step of the way to ensure a smooth, low-lift transition that delivers real results.</p>
                      <div className="flex items-baseline justify-center my-6">
                          <img className="w-50pct rounded-lg lg:mb-0 lg:flex" src="/assets/images/DeliveryImg.png" alt="Delivery Image"/>
                      </div>
                  </div>
              </div>
              {/* <!-- <a href="#" className="text-white bg-purple-600 hover:bg-purple-700 focus:ring-4 focus:ring-purple-200 font-medium rounded-lg text-sm px-7 py-3 text-center dark:text-white dark:focus:ring-purple-900">Get started</a> */}
              <br/>
            <div class="">
                <UsefulButtons.ChatWithTeamHomeButton text="🚀 Ready to get started?" />
            </div>
          </div>
        </section>
      {/* <!-- End block */}

      {/* <!-- Start block */}
      {/* <!-- TODO: Contact Us Form */}
      <section id="getInTouch" className="bg-gray-50 dark:bg-gray-800">
          <div className="max-w-screen-xl px-4 py-10 mx-auto lg:py-24 lg:px-6 text-center">
              <div className="max-w-screen-sm mx-auto text-center">
                <h2 className="mb-10 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">Automate, Optimise, and Grow with DataPulse AI!</h2>
                <span class="font-light text-gray-500 dark:text-gray-400 md:text-lg">Book a <text class="text-title-purple font-semibold">FREE 15-min Discovery call</text> to see how automation could transform your company!</span><br/>

                <div class="p-4 mt-2">
                  <a
                    href="https://api.whatsapp.com/send/?phone=447447164108&text=Hi%20DataPulse%20AI%20%F0%9F%91%8B%20I%27d%20love%20to%20learn%20more%20about%20what%20you%20can%20do!&type=phone_number&app_absent=0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-semibold rounded-lg text-xl px-5 py-3 focus:outline-none"
                  >
                    <img
                      src="/assets/images/whatsapp.svg"
                      alt="WhatsApp"
                      className="w-6 h-6 mr-2"
                    />
                    Get in touch on WhatsApp!
                  </a>

                </div>
                <div class="p-4">
                    <text class="mt-2 text-xl text-gray-400 font-bold">- or add your details here -</text>
                </div>


                </div>

            <TallyEmbed/>
          </div>
      </section>
      {/* <!-- End block */}

      {/* <!-- Start block */}
      <FAQAccordion />
      {/* <!-- End block */}
    </main>

    <Footer />
    </>
  );
}

export default Home;
